import BasicInfoCard from "./BasicInfoCard";
import AccountDetailsCard from "./AccountDetailsCard";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function PersonalInfoTab({
  basicInfo,
  onShowToast,
  getCompanyProfile,
}) {
  return (
    <div className={styles.contentGrid}>
      <div className={styles.contentMain}>
        <BasicInfoCard
          info={basicInfo}
          onShowToast={onShowToast}
          getCompanyProfile={getCompanyProfile}
        />
      </div>
      <div className={styles.contentSide}>
        <AccountDetailsCard details={basicInfo} />
      </div>
    </div>
  );
}
